var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"from-until-dates"},[_c('date-picker',{attrs:{"value":_vm.from_date,"label":"Fecha Inicio"},on:{"setDate":_vm.setFrom}}),_c('date-picker',{attrs:{"value":_vm.until_date,"label":"Fecha Fin"},on:{"setDate":_vm.setUntil}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }